<!--
 * @Descripttion: 
 * @version: 
 * @Author: dengyao
 * @Date: 2023-12-19 20:08:23
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-12-20 11:14:41
-->
<template>
  <InputGroup compact v-if="item.group">
    <Row type="flex" style="width: 100%; display: flex">
      <Col :span="8">
        <FormItemRest>
          <Select
            style="width: 100%"
            v-model:value="searchParam[item.groupProp!]"
            :options="item.groupSelectDic"
            @change="groupSelectChange"
          >
          </Select>
        </FormItemRest>
      </Col>
      <Col :span="16">
        <slot></slot>
      </Col>
    </Row>
  </InputGroup>
</template>
<script setup lang="ts" name="InputGroup">
  import { Select, FormItemRest, InputGroup, Col, Row } from 'ant-design-vue'
  import type { SelectProps } from 'ant-design-vue'
  import { ColumnProps } from '@/components/model/tableModel'
  interface ISearchFormItem {
    item: Partial<ColumnProps> // 具体每一个搜索项的配置
    searchParam: Record<string, any> // 搜索参数
  }

  const props = defineProps<ISearchFormItem>()
  const { searchParam } = props
  const groupSelectChange: SelectProps['onChange'] = (value) => {
    value === 'SENDER' ? (searchParam['recipientPhone'] = '') : (searchParam['senderPhone'] = '')
  }
</script>
